module.exports = __webpack_public_path__ + "img/37-wzzy.bd731acc.png";